import React, { Component } from 'react'
import { comment } from 'react-icons-kit/fa/comment'
import { ic_comment } from 'react-icons-kit/md/ic_comment'
import { eye } from 'react-icons-kit/fa/eye'
import { heart } from 'react-icons-kit/fa/heart'
import { heartO } from 'react-icons-kit/fa/heartO'
import { close } from 'react-icons-kit/ikons/close'
import { ic_cloud_download } from 'react-icons-kit/md/ic_cloud_download'
import Icon from 'react-icons-kit'
import VideoPlayer from './VideoPlayer'
import * as actions from './actions'
import axios from 'axios'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import CommentSection from './CommentSection'
import PermissionModal from './PermissionModal'
import Button from '@material-ui/core/Button'
import SignIn from './SignIn'
import UserLink from './UserLink'

import './VideoModal.css'


const Video = ({ v }) =>
	<div className='item'>
		<span className='close_modal_x'><Icon size={30} icon={close} /></span>
		<div className='item card' onClick={e => e.stopPropagation()}>
			<h2 className='item_title'>{v.title}</h2>
			<div className="item_content">
				<VideoPlayer src={v.vid_url} thumbnail={v.thumb_url} />
			</div>

			<div className='footer'>
				<div className="user_info">
					<UserLink {...v.uploader} />
					<span className='stat comment_date'>{new Date(v.created).toLocaleString()}</span>
				</div>
				<div className="stats stats_right">
					<span className='stat like_icon' onClick={() => v.toggleLike(v.short_code)}>
						{v.liked ? <Icon size={20} icon={heart} style={{ color: '#ff007d' }} /> : <Icon size={20} icon={heartO} />}
						&nbsp;{v.likes}
					</span>
					<span className='stat'><Icon size={20} icon={eye} />&nbsp;{v.views}</span>
					<span className='stat'><Icon size={20} icon={ic_cloud_download} />&nbsp;{v.downloads}</span>
					<span className='stat'><Icon size={20} icon={ic_comment} />&nbsp;{v.comments.length}</span>
					<a href={v.download_url} className='download_btn'>
						<button className="custom_btn"><Icon size={15} icon={ic_cloud_download} />&nbsp;Download</button>
					</a>
				</div>
			</div>
		</div>
	</div>

let BUTTON_LINKS = {
	sign_in: <SignIn><Button color="primary">Sign In</Button></SignIn>,
	buy_premium: <Link to='/store'><Button color="primary">Buy Premium</Button></Link>,
	upgrade: <Link to='/store'><Button color="primary">Upgrade</Button></Link>
}


class VideoModal extends Component {
	state = {
		error: '',
		permission_modal: false,
		link: '',
	}
	componentDidMount() {
		this.checkPermission()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.v.short_code != this.props.v.short_code) {
			this.checkPermission()
		}
	}

	checkPermission = () => {
		let { v, setLoginData, clearLoginData } = this.props

		v.short_code && axios.get(`/api/check_permission/${v.short_code}`)
			.then(r => {
				let { access_token, username, premium } = r.data // whether logged in or not
				access_token ? setLoginData(access_token, username, premium) : clearLoginData()

				let { permission_granted, error, button_link } = r.data
				!permission_granted && this.setState({
					error,
					permission_modal: true,
					link: BUTTON_LINKS[button_link]
				})
			})
	}

	render() {
		let { toggleModal, modal_active, v } = this.props
		let { error, permission_modal, link } = this.state

		return <>
			{modal_active &&
				<div className="modal">
					<div className="background" onClick={toggleModal}>
					</div>
					<div className="foreground" onClick={toggleModal}>
						<Video v={v} />
						<CommentSection v={v} />
					</div>
					<PermissionModal error={error} open={permission_modal} link={link}
						handleClose={() => this.setState({ permission_modal: false, error: '', link: '' })} />
				</div>
			}
		</>

	}
}

let mapStateToProps = state => ({
	username: state.username,
	premium: state.premium,
	access_token: state.access_token
})

const mapDispatchToProps = dispatch => ({
	setLoginData: (access_token, username, premium) => dispatch(actions.setLoginData(access_token, username, premium)),
	clearLoginData: () => dispatch(actions.clearLoginData())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VideoModal))